import { Component, ViewEncapsulation, computed, input, output } from '@angular/core';
import { DateRangePipe } from '../../advocacy-group/contest-sheets/contest-sheets.pipes';
import { StoryDaysUntilDatePipe, StoryParsePipe } from '../story-modal/story-modal.pipes';

/**
 * Broadcast "choose goal" step — lets the hotelier pick a goal (leads via Story
 * Explorer, storytellers via an active contest, or website visits) and emits the
 * chosen goal to the host flow.
 */
@Component({
    selector: 'ft-broadcast-choose-goal-ng',
    imports: [StoryParsePipe, StoryDaysUntilDatePipe, DateRangePipe],
    encapsulation: ViewEncapsulation.None,
    templateUrl: './ft-broadcast-choose-goal.component.html',
    styleUrls: ['./ft-broadcast-choose-goal.component.scss'],
})
export class FtBroadcastChooseGoalComponent {
    readonly story = input<any>();
    readonly contests = input<any>();
    readonly inviteToStory = output<void>();
    readonly inviteToContest = output<any>();
    readonly inviteToWebsite = output<void>();

    protected readonly isQuoteOnly = computed(() => (!!this.story() ? !this.story().guest.poststay.photo : false));

    protected inviteToGuestPage(): void {
        this.inviteToStory.emit();
    }

    protected onInviteToContest(contest: any): void {
        this.inviteToContest.emit(contest);
    }

    protected onInviteToWebsite(): void {
        this.inviteToWebsite.emit();
    }
}
